import { render, staticRenderFns } from "./StepNumber.vue?vue&type=template&id=2e80790a&scoped=true"
import script from "./StepNumber.vue?vue&type=script&lang=js"
export * from "./StepNumber.vue?vue&type=script&lang=js"
import style0 from "./StepNumber.vue?vue&type=style&index=0&id=2e80790a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e80790a",
  null
  
)

export default component.exports